import React from "react";
import { mandatoryColumns } from "../../constants/static";
import SortOrderIndicators from "../SortOrderIndicators";

export default function FilterGroupColumnTHs(props) {
  if (!props.filterGroups?.length > 0) {
    return null;
  }

  let filteredGroups = props.filterGroups.filter(
    (x) => x.type < 4 && !x.hideAsColumn && x.id !== mandatoryColumns.ItemCategoryTitle
  );

  return filteredGroups?.map((filterRow) => {
    let isCurrent = filterRow.id === props.sortProperty;

    return (
      <th className="c-parts-listing__table-header" key={filterRow.id}>
        <div className="d-flex">
          <div
            className="c-parts-listing__select"
            onClick={() => props.changeSortProperty(filterRow)}
            style={{ textDecoration: isCurrent ? "underline" : "none", cursor: "pointer" }}
          >
            {filterRow.text}
          </div>
          <SortOrderIndicators
            sortType={props.sortType}
            sortProperty={props.sortProperty}
            currentProperty={filterRow.id}
          />
        </div>
      </th>
    );
  });
}
